import React from "react";

import { Grid, Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CommonCheckbox } from "common/components";

import {
  showFile,
  ShowFile,
  DocumentType,
} from "services/fake/fakeDocumentManager";

const TermsCheckbox = ({ id, errors, setFieldValue, values, touched }: any) => {
  //Hooks
  const { t } = useTranslation();

  const checkboxTexts = {
    termsFinproAG: {
      text: t("I have read and agree with terms and conditions of Finpro AG"),
      file: DocumentType.TermsFinproAG,
    },
    termsEffectaGmbh: {
      text: t(
        "I have read and agree with terms and conditions of Effecta GmbH"
      ),
      file: DocumentType.TermsEffecta,
    },
  };

  return (
    <Grid container item>
      <Grid item xs={12} md={10}>
        <CommonCheckbox
          id={id}
          values={values}
          errors={errors}
          touched={touched}
          setFieldValue={setFieldValue}
          label={checkboxTexts[id].text}
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <Button
          className="primary"
          onClick={() => showFile(ShowFile.Open, checkboxTexts[id].file)}
          style={{}}
          fullWidth
          variant="contained"
        >
          {t("Read")}
        </Button>
      </Grid>
    </Grid>
  );
};

export const TermsSubform = ({
  errors,
  setFieldValue,
  values,
  touched,
}: any) => (
  <Grid container direction="column" spacing={3}>
    <TermsCheckbox
      id="termsFinproAG"
      errors={errors}
      values={values}
      touched={touched}
      setFieldValue={setFieldValue}
    />

    <TermsCheckbox
      id="termsEffectaGmbh"
      errors={errors}
      values={values}
      touched={touched}
      setFieldValue={setFieldValue}
    />
  </Grid>
);
